<dx-header-curve></dx-header-curve>
<dx-page-navbar></dx-page-navbar>
<div class="page-container container-fluid">
  <ng-container *ngIf="(policy$ | async) as policy; else loadingOrError">
    <dx-page-header title="Policy Inquiry"></dx-page-header>
    <div class="row mb-3">
      <div class="col-12 col-md-6 col-xl-7 pb-3 pb-md-0">
        <div class="text-secondary">Policy</div>
        <dx-policy-dropdown [accountNumber]="policy.accountNumber" [selectedPolicyNumber]="policy.policyNumber"
          [policyRoute]="policyRoute">
        </dx-policy-dropdown>
      </div>
      <div class="col-12 col-md pb-3 order-md-3">
        <div class="text-secondary">Policy Term</div>
        <div class="d-inline">
          <span class="text-secondary pe-2">EFF</span>
          <span class="h5 fw-normal pe-3">{{ policy.effectiveDate }}</span>
        </div>
        <div class="d-inline">
          <span class="text-secondary pe-2">EXP</span>
          <span class="h5 fw-normal pe-3">{{ policy.expirationDate }}</span>
        </div>
        <div class="d-inline">
          <span class="h5">
            <dx-policy-status [status]="policy.policyStatus"></dx-policy-status>
          </span>
        </div>
      </div>
      <div class="col-12 col-md-6 col-xl-5 order-md-2 pb-3 pb-md-0">
        <div class="text-secondary">Insured</div>
        <a class="btn btn-light card" routerLink="/account/{{policy.accountNumber}}">
          <div class="card-body">
            <div class="row align-items-center g-0">
              <div class="col-auto me-1">
                <fa-layers [fixedWidth]="true" size="3x">
                  <fa-icon class="icon-gray" [icon]="['fas', 'circle']"></fa-icon>
                  <fa-icon class="text-primary" [icon]="faUserShield" transform="shrink-8"></fa-icon>
                </fa-layers>
              </div>
              <div class="col text-start me-1">
                <div class="h6 mb-0">
                  {{policy.insuredName}}<br>
                  <span class="text-primary">#{{policy.accountNumber}}</span>
                </div>
              </div>
              <div class="col-auto">
                <fa-icon class="text-primary" [fixedWidth]="true" [icon]="['fas', 'chevron-right']"></fa-icon>
              </div>
            </div>
          </div>
        </a>
      </div>
      <div class="col-12 col-md order-4 text-end align-self-center"></div>
    </div>
    <div class="row">
      <div class="col">
        <div class="card">
          <nav>
            <ul ngbNav [(activeId)]="activeTab" class="nav-pills">
              <li ngbNavItem="summary">
                <a ngbNavLink routerLink="summary">Summary</a>
              </li>
              <li ngbNavItem="transactions">
                <a ngbNavLink routerLink="transactions">Transactions</a>
              </li>
              <li ngbNavItem="billing">
                <a ngbNavLink routerLink="billing">Billing</a>
              </li>
              <li ngbNavItem="claims">
                <a ngbNavLink routerLink="claims">Claims</a>
              </li>
              <li ngbNavItem="documents">
                <a ngbNavLink routerLink="documents">Documents</a>
              </li>
            </ul>
          </nav>
          <div class="card-body">
            <router-outlet></router-outlet>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
  <ng-template #loadingOrError>
    <ng-container *ngIf="(hasError$ | async); else loading">
      <ng-container *ngIf="error.status === 404; else pageError">
        <dx-not-found></dx-not-found>
      </ng-container>
      <ng-template #pageError>
        <dx-page-error [status]="error.status"></dx-page-error>
      </ng-template>
    </ng-container>
    <ng-template #loading>
      <dx-page-loading title="Policy Inquiry" cardHeight="800px"></dx-page-loading>
    </ng-template>
  </ng-template>
</div>
